export default __webpack_public_path__ + "static/media/white-identify-pan-icon.9702cf86.svg";